import { Div, Button, router, ldb } from '@codesuma/baseline'
import settings from '../../../services/settings'
import style from './index.module.css'

// Said once: that Emrouz can carry the holidays of the country you live in
// alongside Iran's.
//
// The directory is behind the menu and behind the gear, and nobody opens
// either looking for a feature they have not heard of. One tap goes there; so does leaving it, and
// either way this never comes back.

const SEEN = 'country-intro-seen'

// Nothing to say to someone who has already added a country, or already
// been told.
export const countryIntroDue = () =>
    !ldb.get(SEEN) && settings.get().countries.length === 0

// Remembered before either answer is acted on, so a mid-flight close still
// counts as told.
const markSeen = () => ldb.set(SEEN, '1')

export const CountryIntro = () => {
    const base = Div()
    base.addClass(style.base)

    const panel = Div()
    panel.addClass(style.panel)
    base.append(panel)

    const heading = Div('تعطیلات و رویدادهای کشور محل زندگی‌تان را اضافه کنم؟')
    heading.addClass(style.heading)
    panel.append(heading)

    const text = Div('اگر بیرون از ایران زندگی می‌کنید، امروز می‌تواند رویدادها و تعطیلات رسمی کشور محل زندگی‌تان را هم کنار تقویم ایران نشان دهد.')
    text.addClass(style.text)
    panel.append(text)

    const where = Div('هر وقت خواستید می‌توانید از تنظیمات کشوری را اضافه یا حذف کنید.')
    where.addClass(style.where)
    panel.append(where)

    const actions = Div()
    actions.addClass(style.actions)
    panel.append(actions)

    const yes = Button('کشورها را نشانم بده')
    yes.addClass(style.primary)
    yes.on('click', () => {
        markSeen()
        // Navigate first. 'close' hands the sheet to the home page to remove,
        // and anything that goes wrong in that teardown must not be what stops
        // the one tap this sheet exists to offer.
        router.goto('/countries')
        base.emit('close')
    })
    actions.append(yes)

    const later = Button('بعدا')
    later.addClass(style.secondary)
    later.on('click', () => {
        markSeen()
        base.emit('close')
    })
    actions.append(later)

    // The backdrop is not an answer, so it does not dismiss: this is asked once
    // and a stray tap should not be what spends that one time.
    return base
}
